var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"apex-charts",attrs:{"id":"line-column-chart","dir":"ltr"}}),(_vm.show)?_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"280","dir":"ltr","series":_vm.barChart.series,"options":_vm.barChart.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }